import { supabase, isSupabaseConfigured } from '../lib/supabase';

/**
 * Service Service
 * Functions for fetching services from the database
 * Public-facing functions (no admin verification required)
 */

/**
 * Get all active services, ordered by display_order
 * @returns {Promise<{success: boolean, data: Array, error?: string}>}
 */
export async function getAllServices() {
  if (!isSupabaseConfigured) {
    return { success: false, error: 'Supabase not configured', data: [] };
  }

  try {
    const { data, error } = await supabase
      .from('services')
      .select('*')
      .eq('is_active', true)
      .order('display_order', { ascending: true })
      .order('created_at', { ascending: true });

    if (error) throw error;

    return { success: true, data: data || [] };
  } catch (error) {
    console.error('Error fetching services:', error);
    return { success: false, error: error.message, data: [] };
  }
}

/**
 * Get a single service by ID
 * @param {string} serviceId - Service UUID
 * @returns {Promise<{success: boolean, data: Object|null, error?: string}>}
 */
export async function getServiceById(serviceId) {
  if (!isSupabaseConfigured) {
    return { success: false, error: 'Supabase not configured', data: null };
  }

  if (!serviceId) {
    return { success: false, error: 'Service ID is required', data: null };
  }

  try {
    const { data, error } = await supabase
      .from('services')
      .select('*')
      .eq('id', serviceId)
      .eq('is_active', true)
      .single();

    if (error) throw error;

    return { success: true, data: data || null };
  } catch (error) {
    console.error('Error fetching service:', error);
    return { success: false, error: error.message, data: null };
  }
}
